const ChevronRight24 = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.96967 3.46967C8.26256 3.17678 8.73744 3.17678 9.03033 3.46967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.03033 20.5303C8.73744 20.8232 8.26256 20.8232 7.96967 20.5303C7.67678 20.2374 7.67678 19.7626 7.96967 19.4697L15.4393 12L7.96967 4.53033C7.67678 4.23744 7.67678 3.76256 7.96967 3.46967Z"
      fill="black"
    />
  </svg>
)

export default ChevronRight24
